import { useEffect, useState } from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { FaCrown } from "react-icons/fa";
import CustomSvg from "../components/svgs/CustomSvg";
import { useNavigate, useParams } from "react-router-dom";
import { getRequest } from "../components/apiRequests/requestApi";

const Leaderboard = () => {
  const navigate = useNavigate();
  const { tournamentId } = useParams();
  const [leaderboard, setLeaderboard] = useState([]);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const res = await getRequest(`/tournament/${tournamentId}/leaderboard`);
        const sorted = res.data
          .filter((player) => player._id)
          .sort((a, b) => b.totalWins - a.totalWins);
        setLeaderboard(sorted);
      } catch (err) {
        // console.error(err);
      }
    };

    fetchLeaderboard();
  }, [tournamentId]);

  const topThree = leaderboard.slice(0, 3);
  const rest = leaderboard.slice(3, 10);

  const getUsername = (user) => user?.userInfo?.[0]?.username || "Unknown";
  const getAvatar = (user) =>
    user?.userInfo?.[0]?.avatar ||
    `https://ui-avatars.com/api/?name=${getUsername(user)}`;

  return (
    <div className="bg-[#130828] min-h-svh p-3 text-white">
      {/* Header */}
      <div className="relative flex items-center justify-center py-10">
        <div className="absolute -left-1">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-white"
          >
            <CustomSvg name="arrow-left" width={20} height={20} color="#fff" />
            <AiOutlineArrowLeft size={24} />
          </button>
        </div>
        <h2 className="text-xl font-bold bg-gradient-to-r from-[#C6BCFF] to-[#3F9217] bg-clip-text text-transparent text-center">
          Leaderboard
        </h2>
      </div>

      {/* Crown Icon */}
      <div className="flex justify-center mb-4">
        <FaCrown className="text-yellow-400 text-3xl" />
      </div>

      {/* Top 3 */}
      <div className="flex justify-center items-end gap-4 mt-6 mb-10">
        {/* 2nd */}
        {topThree[1] && (
          <div className="flex flex-col items-center">
            <span className="text-sm text-silver font-semibold">2nd</span>
            <img
              src={getAvatar(topThree[1])}
              alt="2nd"
              className="w-20 h-20 rounded-full border-4 border-silver"
            />
            <p className="mt-2 text-sm">{getUsername(topThree[1])}</p>
            <p className="text-xs">🏆 {topThree[1].totalWins} wins</p>
          </div>
        )}
        {/* 1st */}
        {topThree[0] && (
          <div className="flex flex-col items-center">
            <span className="text-sm text-gold font-semibold">1st</span>
            <img
              src={getAvatar(topThree[0])}
              alt="1st"
              className="w-24 h-24 rounded-full border-4 border-gold"
            />
            <p className="mt-2 font-semibold">{getUsername(topThree[0])}</p>
            <p className="text-sm">🏆 {topThree[0].totalWins} wins</p>
          </div>
        )}
        {/* 3rd */}
        {topThree[2] && (
          <div className="flex flex-col items-center">
            <span className="text-sm text-bronze font-semibold">3rd</span>
            <img
              src={getAvatar(topThree[2])}
              alt="3rd"
              className="w-20 h-20 rounded-full border-4 border-bronze"
            />
            <p className="mt-2 text-sm">{getUsername(topThree[2])}</p>
            <p className="text-xs">🏆 {topThree[2].totalWins} wins</p>
          </div>
        )}
      </div>

      {/* Top 10 Remaining */}
      <div className="px-2">
        {rest.map((user, idx) => (
          <div
            key={user._id}
            className="flex items-center justify-between p-3 rounded-lg mb-3 bg-[#21624F]"
          >
            <div className="flex items-center gap-3">
              <span className=" text-white text-sm">{idx + 4}</span>
              <img
                src={getAvatar(user)}
                alt="user"
                className="w-10 h-10 rounded-full"
              />
              <span className="text-white">{getUsername(user)}</span>
            </div>
            <span className="text-white font-semibold">
              {user.totalWins} wins
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Leaderboard;
